import { PostType } from '@/graphql/generated/types.generated';
import {
    DonutLargeRounded,
    LibraryBooksRounded,
    LinkRounded,
    PhotoLibraryRounded,
    SubscriptionsRounded,
} from '@mui/icons-material';
import { Icon, IconProps } from '@mui/material';

type PostTypeIconProps = {
    type: PostType;
} & IconProps;
const PostTypeIcon = ({ type, sx, ...iconProps }: PostTypeIconProps) => {
    const mapPostTypeIcon: Record<PostType, React.ReactNode> = {
        LINK: <LinkRounded fontSize="inherit" />,
        MEDIA: <PhotoLibraryRounded fontSize="inherit" />,
        STATUS: <LibraryBooksRounded fontSize="inherit" />,
        STORY: <DonutLargeRounded fontSize="inherit" />,
        REEL: <SubscriptionsRounded fontSize="inherit" />,
    };

    return (
        <Icon
            sx={[
                (theme) => ({
                    display: 'flex',
                    ...(theme.palette.mode === 'dark' && {
                        color: 'var(--mui-palette-text-primary)',
                    }),
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...iconProps}
        >
            {mapPostTypeIcon[type]}
        </Icon>
    );
};
export default PostTypeIcon;
